import { Referral as Api } from '@synapex/shared2/gateway-rest-api';

import { parseDateField } from '../../utils';

export const referral = (data: Api.getMany.Reply[number]) => {
  parseDateField(data, 'created_at');

  return data;
};

export const referralManyReply = (data: Api.getMany.Reply) => {
  for (const item of data) {
    referral(item);
  }

  return data;
};
